import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { AuthorProfile } from "../types/author.types";

export function useAuthorProfile(userId: string | null): AuthorProfile {
	const [profile, setProfile] = useState<AuthorProfile>({ name: null, bio: null, bannerColor: null, followerCount: 0 });

	useEffect(() => {
		if (!userId) return;
		return onSnapshot(doc(db, "users", userId), (snap) => {
			const data = snap.data() ?? {};
			setProfile({
				name: data.name ?? null,
				bio: data.bio ?? null,
				bannerColor: data.bannerColor ?? null,
				followerCount: data.followerCount ?? 0,
			});
		});
	}, [userId]);

	return profile;
}
